
import { FormularioAsignarColaborador, TablaItemsProduccion } from "../components";
import { LayoutCrearDoc } from "../../layouts";
import { useItemsTodosCarritos } from "../../../hooks/cache";
import { BuscadorXTermino } from "../../components/buscadores";
import { CargandoMedio, ModalFormulario } from "../../components";
import { useCarritoItemsStore, useModalStore } from "../../../stores";





export const TodosLosItems = () => {

        
    const { data, isLoading, chagePage, page, termino, chageTermino } = useItemsTodosCarritos();
    const { itemActivo } = useCarritoItemsStore();
    const { modalFormToggle } = useModalStore();


    return (

        <LayoutCrearDoc titulo='Todos Los Items' add={false}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de items de producción..." />
            :   <>
                <BuscadorXTermino mT={3} termino={termino} chageTermino={chageTermino} texto="item" playhol="op usuario movil producto" />
                <TablaItemsProduccion data={data || []} chagePage={chagePage} page={page} />
                </>
            }

            <ModalFormulario titulo="Editar Items Producción" valor={{}} onClose={() => modalFormToggle(false)}>
                <FormularioAsignarColaborador selected={[itemActivo]} setSelected={null} />
            </ModalFormulario>
        </LayoutCrearDoc>
    )
}









